// extracted by mini-css-extract-plugin
module.exports = {"container":"o_oN975e","title":"XwzjAvDi","subtitle":"tgcneHM3","cover":"nHIwZtf5","backButton":"nzz2Egn7"};